import { TOGGLE_VIEW_LISTS_ALL, TOGGLE_VIEW_LISTS_STARRED, TOGGLE_MSG_STARRED_MAXIMUM } from '../actions/actions_view';

const initialState = {
    viewLists: 'all',
    showMsgStarredMaximum: false
};

export default function(state = initialState, action) {
	let newState = Object.assign({}, state);

	switch (action.type) {
        case TOGGLE_VIEW_LISTS_ALL:
            newState.viewLists = 'all';
            return newState;
            
        case TOGGLE_VIEW_LISTS_STARRED:
            newState.viewLists = 'starred';
            return newState;
            
        case TOGGLE_MSG_STARRED_MAXIMUM:
            newState.showMsgStarredMaximum = action.newStatus;
			return newState;

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_view.js